<template>
  <div class="account-wrap">
    <!-- 头部卡片 -->
    <div class="card header-card">
      <div class="search-group">
        <span class="search-title">账号查询</span>
        <input v-model="searchAccount" class="search-input" placeholder="输入要查询的账号" />
        <button class="btn primary-btn" @click="searchAccountInfo">查找</button>
      </div>

      <div class="operate-group">
        <div class="btn-group">
          <span class="group-tip">数据操作</span>
          <button class="btn success-btn" @click="saveToDb">写入数据库</button>
          <button class="btn default-btn" @click="addOneAccount">增加一个</button>
          <button class="btn danger-btn" @click="delAccount">删除账号</button>
        </div>
        <div class="btn-group">
          <span class="group-tip">测试/运维</span>
          <button class="btn info-btn" @click="createTestAccount">注册压测账号</button>
          <button class="btn warning-btn" @click="mergeServer">合区</button>
        </div>
      </div>
    </div>

    <!-- 表单卡片 -->
    <div class="card form-card">
      <div class="form-header">
        <h3 class="card-title">账号信息编辑</h3>
        <button class="btn success-btn" @click="saveFormData">保存修改</button>
      </div>

      <div class="form-top-row">
        <label class="form-label">账号</label>
        <input v-model="formData.Account" class="form-input" />
      </div>

      <!-- 分组表单网格 -->
      <div class="form-grid">
        <!-- ========== 账号基础信息组 ========== -->
        <div class="group-title">账号基础信息</div>
        <div class="form-item">
          <label>主键标识</label>
          <input v-model="formData.PrimaryKey" class="form-input" />
        </div>
        <div class="form-item">
          <label>密码</label>
          <input v-model="formData.PassWord" class="form-input" />
        </div>
        <div class="form-item">
          <label>用户名称</label>
          <input v-model="formData.UserName" class="form-input" />
        </div>
        <div class="form-item">
          <label>出生日期</label>
          <input v-model="formData.Birth" class="form-input" />
        </div>
        <div class="form-item">
          <label>地址</label>
          <input v-model="formData.Address" class="form-input" />
        </div>
        <div class="form-item">
          <label>身份证号</label>
          <input v-model="formData.NativeNumber" class="form-input" />
        </div>
        <div class="form-item">
          <label>主密钥</label>
          <input v-model="formData.MasterKey" class="form-input" />
        </div>
        <div class="form-item">
          <label>邮箱</label>
          <input v-model="formData.Email" class="form-input" />
        </div>
        <div class="form-item">
          <label>手机号</label>
          <input v-model="formData.Phone" class="form-input" />
        </div>
        <div class="form-item">
          <label>监护人姓名</label>
          <input v-model="formData.ParentName" class="form-input" />
        </div>
        <div class="form-item">
          <label>监护人身份证</label>
          <input v-model="formData.ParentNativeNumber" class="form-input" />
        </div>

        <!-- ========== 角色&服务器组 ========== -->
        <div class="group-title">角色与服务器</div>
        <div class="form-item">
          <label>角色1名称</label>
          <input v-model="formData.Char1_name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色1服务器</label>
          <input v-model="formData.Server1_Name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色2名称</label>
          <input v-model="formData.Char2_name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色2服务器</label>
          <input v-model="formData.Server2_Name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色3名称</label>
          <input v-model="formData.Char3_name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色3服务器</label>
          <input v-model="formData.Server3_Name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色4名称</label>
          <input v-model="formData.Char4_name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色4服务器</label>
          <input v-model="formData.Server4_Name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色5名称</label>
          <input v-model="formData.Char5_name" class="form-input" />
        </div>
        <div class="form-item">
          <label>角色5服务器</label>
          <input v-model="formData.Server5_Name" class="form-input" />
        </div>

        <!-- ========== 附加信息组 ========== -->
        <div class="group-title">附加信息</div>
        <div class="form-item">
          <label>登录IP</label>
          <input v-model="formData.IpAddr" class="form-input" />
        </div>
        <div class="form-item">
          <label>创建时间</label>
          <input v-model="formData.MakeDate" class="form-input" />
        </div>
        <div class="form-item">
          <label>最后登录时间</label>
          <input v-model="formData.LastDate" class="form-input" />
        </div>
      </div>
    </div>

    <!-- 接口返回日志卡片 -->
    <div class="card log-card" v-if="dbRes">
      <div class="log-title">接口返回日志</div>
      <pre class="log-content">{{ dbRes }}</pre>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['serverName'])
import { reactive, ref } from 'vue'
import { showToast } from '@/utils/toast'
const baseUrl = "https://log.wuxiahaojie.com/api/FUWUQI"
// 顶部搜索账号
const searchAccount = ref('')
// 底部提示用
const dbRes = ref('')

// 账号完整表单数据模型
// ChangeName字段保留用于兼容接口字段顺序，页面不再展示
const formData = reactive({
  Account: '',
  PrimaryKey: '',
  PassWord: '',
  UserName: '',
  Birth: '',
  Address: '',
  NativeNumber: '',
  MasterKey: '',
  Email: '',
  Phone: '',
  ParentName: '',
  ParentNativeNumber: '',
  Char1_name: '',
  Server1_Name: '',
  ChangeName1: false,

  Char2_name: '',
  Server2_Name: '',
  ChangeName2: false,

  Char3_name: '',
  Server3_Name: '',
  ChangeName3: false,

  Char4_name: '',
  Server4_Name: '',
  ChangeName4: false,

  Char5_name: '',
  Server5_Name: '',
  ChangeName5: false,

  IpAddr: '',
  MakeDate: '',
  LastDate: ''
})

/**
 * 通用：解析逗号字符串填充表单
 * @param {string} str 后端返回逗号分割字符串
 */
function parseStrFillForm(str) {
  const arr = str.split(',')
  formData.Account = arr[0] ?? ''
  formData.PassWord = arr[1] ?? ''
  formData.UserName = arr[2] ?? ''
  formData.Birth = arr[3] ?? ''
  formData.MakeDate = arr[4] ?? ''
  formData.Address = arr[5] ?? ''
  formData.NativeNumber = arr[6] ?? ''
  formData.MasterKey = arr[7] ?? ''
  formData.PrimaryKey = arr[8] ?? ''
  formData.Email = arr[9] ?? ''
  formData.Phone = arr[10] ?? ''

  formData.Char1_name = arr[11] ?? ''
  formData.Char2_name = arr[12] ?? ''
  formData.Char3_name = arr[13] ?? ''
  formData.Char4_name = arr[14] ?? ''
  formData.Char5_name = arr[15] ?? ''

  formData.Server1_Name = arr[16] ?? ''
  formData.Server2_Name = arr[17] ?? ''
  formData.Server3_Name = arr[18] ?? ''
  formData.Server4_Name = arr[19] ?? ''
  formData.Server5_Name = arr[20] ?? ''

  formData.ParentName = arr[21] ?? ''
  formData.ParentNativeNumber = arr[22] ?? ''
  formData.IpAddr = arr[23] ?? ''
  formData.LastDate = arr[24] ?? ''

  formData.ChangeName1 = false
  formData.ChangeName2 = false
  formData.ChangeName3 = false
  formData.ChangeName4 = false
  formData.ChangeName5 = false
}

/**
 * 导出当前表单数据为后端兼容逗号字符串
 * @returns {string} 同格式逗号分隔字符串
 */
function getSubmitString() {
  const arr = [
    formData.Account,
    formData.PassWord,
    formData.UserName,
    formData.Birth,
    formData.MakeDate,
    formData.Address,
    formData.NativeNumber,
    formData.MasterKey,
    formData.PrimaryKey,
    formData.Email,
    formData.Phone,
    formData.Char1_name,
    formData.Char2_name,
    formData.Char3_name,
    formData.Char4_name,
    formData.Char5_name,
    formData.Server1_Name,
    formData.Server2_Name,
    formData.Server3_Name,
    formData.Server4_Name,
    formData.Server5_Name,
    formData.ParentName,
    formData.ParentNativeNumber,
    formData.IpAddr,
    formData.LastDate
  ]
  return arr.join(',')
}

// 1. 查找账号 logingetuser
const searchAccountInfo = () => {
  const name = searchAccount.value.trim()
  if (!name) {
    dbRes.value = '请输入账号再查询'
    return
  }
  const url = `${baseUrl}/logingetuser?servername=${props.serverName}&name=${encodeURIComponent(name)}`
  fetch(url)
    .then(res => res.text())
    .then(ret => {
      dbRes.value = `查询账号返回：${ret}`
      parseStrFillForm(ret)
    })
    .catch(err => dbRes.value = `查询账号接口异常：${err.message}`)
}

// 2. 写入数据库 loginsaveuser 完整提交
const saveToDb = () => {
  const name = searchAccount.value.trim() || formData.Account
  if (!name) {
    dbRes.value = '账号不能为空'
    return
  }
  const submitStr = getSubmitString()
  const url = `${baseUrl}/loginsaveuser?servername=${props.serverName}&name=${encodeURIComponent(name)}&data=${encodeURIComponent(submitStr)}`
  fetch(url)
    .then(res => res.text())
    .then(ret => dbRes.value = `全部账号数据保存成功：${ret}`)
    .catch(err => dbRes.value = `保存账号异常：${err.message}`)
}

// 3. 增加一个（本地填充测试数据，无接口）
const addOneAccount = () => {
  const testDataStr = "17736725655,9ba59abbe56e057f,,,0:2003-02-07,,,,d243d362eddb914d,,,里斯三,暗影,洋洋,二哥,,星域,星域,星域,星域,,,,"
  parseStrFillForm(testDataStr)
  searchAccount.value = formData.Account
  dbRes.value = '已加载测试账号数据：17736725655'
}

// 4. 注册压测账号 loginyace
const createTestAccount = () => {
  const name = searchAccount.value.trim()
  if (!name) {
    dbRes.value = '请输入账号名称生成压测账号'
    return
  }
  const url = `${baseUrl}/loginyace?servername=${props.serverName}&name=${encodeURIComponent(name)}`
  fetch(url)
    .then(res => res.text())
    .then(ret => dbRes.value = `压测账号创建返回：${ret}`)
    .catch(err => dbRes.value = `创建压测账号异常：${err.message}`)
}

// 5. 删除当前账号（本地清空，无后端接口）
const delAccount = () => {
  if (!formData.Account) {
    dbRes.value = '无当前账号可删除'
    return
  }
  if (confirm(`确认删除账号【${formData.Account}】？`)) {
    Object.keys(formData).forEach(key => {
      if (typeof formData[key] === 'boolean') {
        formData[key] = false
      } else {
        formData[key] = ''
      }
    })
    searchAccount.value = ''
    dbRes.value = '账号表单已清空'
  }
}

// 6. 合区 login合区
const mergeServer = () => {
  const name = searchAccount.value.trim()
  if (!name) {
    dbRes.value = '请输入账号执行合区操作'
    return
  }
  const url = `${baseUrl}/login?servername=${props.serverName}&name=${encodeURIComponent(name)}`
  fetch(url)
    .then(res => res.text())
    .then(ret => dbRes.value = `账号合区接口返回：${ret}`)
    .catch(err => dbRes.value = `合区操作异常：${err.message}`)
}

// 7. 单表单保存按钮，复用保存接口
const saveFormData = () => {
  saveToDb()
}
</script>

<style scoped>
.account-wrap {
  width: 100%;
  padding: 20px;
  background-color: #f7f8fa;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 通用卡片样式 */
.card {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
}

/* 头部卡片 */
.header-card {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.search-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.search-title {
  font-weight: 500;
  font-size: 15px;
}
.search-input {
  padding: 7px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  width: 240px;
  outline: none;
  transition: border 0.2s;
}
.search-input:focus {
  border-color: #409eff;
}

.operate-group {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
.btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.group-tip {
  font-size: 13px;
  color: #888;
}

/* 按钮通用 */
.btn {
  padding: 7px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s;
}
.btn:hover {
  opacity: 0.85;
}
.primary-btn {
  background: #409eff;
  color: #fff;
}
.success-btn {
  background: #67c23a;
  color: #fff;
}
.danger-btn {
  background: #f56c6c;
  color: #fff;
}
.info-btn {
  background: #909399;
  color: #fff;
}
.warning-btn {
  background: #e6a23c;
  color: #fff;
}
.default-btn {
  background: #e4e7ed;
  color: #303133;
}

/* 表单卡片 */
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.card-title {
  margin: 0;
  font-size: 17px;
  color: #303133;
}

.form-top-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.form-label {
  min-width: 130px;
  font-weight: 500;
}
.form-input {
  padding: 7px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  outline: none;
}
.form-input:focus {
  border-color: #409eff;
}

/* 网格表单布局 */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 14px 20px;
}
.form-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.form-item label:first-child {
  min-width: 140px;
  font-size: 14px;
  color: #444;
}
.form-item > .form-input {
  flex: 1;
}

/* 分组标题 */
.group-title {
  grid-column: 1 / -1;
  font-size: 15px;
  font-weight: 600;
  color: #222;
  margin-top:12px;
  padding-bottom:6px;
  border-bottom:1px solid #eee;
}

/* 日志卡片 */
.log-card {
}
.log-title {
  font-weight: 500;
  margin-bottom: 8px;
  color: #303133;
}
.log-content {
  margin: 0;
  padding: 12px;
  background: #1e1e1e;
  color: #a9c7d8;
  border-radius: 6px;
  white-space: pre-wrap;
  font-size: 13px;
  max-height: 240px;
  overflow-y: auto;
}
</style>